(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.add-to-cart-button, [name="add"], button[type="submit"][name="add"]');
    if (!btn) return;

    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || !drawer.showDialog) return;

    requestAnimationFrame(function () {
      drawer.showDialog();
    });
  });
})();
